import React, { useState } from 'react';

const Step9SpicyPhotos = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.spicyPhotos || null);

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          spicyPhotos: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-yesno">
      <div className="analyzing-text">Analyzing your desires...</div>
      <div className="yesno-image-container">
        <img 
          src="https://cdn.lovescape.com/cdn/front/images/marketing/9page.webp" 
          alt="Spicy Photos" 
          className="yesno-image"
        />
      </div>
      <h2 className="step-title">Would you like to receive spicy photos?</h2>
      <div className="yesno-buttons">
        <button 
          className={`yesno-button ${selected === 'yes' ? 'selected' : ''}`}
          onClick={() => handleSelect('yes')}
        >
          Yes
        </button>
        <button 
          className={`yesno-button ${selected === 'no' ? 'selected' : ''}`}
          onClick={() => handleSelect('no')}
        >
          No
        </button>
      </div>
    </div>
  );
};

export default Step9SpicyPhotos;